/**
 * Error-shape helpers. The CartePlus API returns human-readable plain strings
 * in the response body on a 400, so keep those visible to the operator.
 */

/** Pull the server's plain-string body, falling back to a supplied message. */
export function serverErrorMessage(error: any, fallback: string): string {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim() !== "") {
    return data;
  }
  if (typeof data?.message === "string" && data.message.trim() !== "") {
    return data.message;
  }
  if (typeof data?.title === "string" && data.title.trim() !== "") {
    return data.title;
  }
  return fallback;
}

/**
 * A 400 "already complete" is benign on the handheld — the desktop (or another
 * device) completed the same task first. Ported from MaterialInward.tsx:87-96.
 */
export function isAlreadyCompleteError(error: any): boolean {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const message =
    typeof data === "string"
      ? data
      : data?.message ?? data?.title ?? error?.message ?? "";

  return status === 400 && message.toLowerCase().includes("already complete");
}
